module.exports = {
  file: {
    dir_name: 'upload', // 上传文件夹名称
    file_max: 2,  // 文件最大限制
    file_type: [],  // 文件类型
    file_unit: 20,  // 文件大小单位
    templet: 10,  // 模板类型
    checkAllFile: false // 全选文件类型
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/file.js